<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Certificate Template</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="certificate_template_list" class="elevation-1 mytable" dense
        :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-btn class="ma-2 no-display" rounded outlined small color="success" @click="downloadFile"
              :loading="loader"><v-icon>mdi-export</v-icon>Export</v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="900px">
              <template v-slot:activator="{ on }">
                <v-btn small dense class="button" v-on="on">Add Certificate Template</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-text-field dense outlined v-model="addedItem.certificate_template_name"
                          label="Certificate Template"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" style="margin-top: -30px;" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-textarea outlined name="input-7-4" rows="15" v-model="addedItem.template"
                          label="Enter Template/HTML Code"></v-textarea>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" style="margin-top: -30px;" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="addedItem.participant_type_id" :items="participant_type_list"
                          item-text="participant_name" item-value="id" label="Select Participant Type" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" style="margin-top: -30px;" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="addedItem.affiliaton_type_id" :items="affiliation_type_list"
                          item-text="affiliaton_type" item-value="id" label="Select Affiliation Type" outlined persistent-hint>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" style="margin-top: -30px;" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="addedItem.activity_certificate_id"
                          :items="activity_certificate_list" item-text="activity_certificate_name" item-value="id"
                          label="Select Certificate Type" outlined persistent-hint>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" style="margin-top: -30px;" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="addedItem.academic_year_id" :items="academic_year_list"
                          item-text="academic_year" item-value="id" label="Select Academic Year" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" style="margin-top: -30px;" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="addedItem.activity_id"
                          :items="activity_list" item-text="activity_title" item-value="activity_id" label="Select Activity" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.certificate_template_name" dense persistent-hint
                          label="Certificate Template"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" v-if="editedIndex != -1">
                        <v-textarea outlined rows="15" dense v-model="editedItem.template"
                          label="Edit Template/HTML Code"></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete v-model="editedItem.participant_type_id" :items="participant_type_list" item-text="participant_name" item-value="id" dense outlined persistent-hint
                          label="Participant Type"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete v-model="editedItem.affiliaton_type_id" :items="affiliation_type_list" item-text="affiliaton_type" item-value="id" dense outlined persistent-hint
                          label="Affiliation Type"></v-autocomplete>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete v-model="editedItem.activity_certificate_id" :items="activity_certificate_list" item-text="activity_certificate_name" item-value="id" dense outlined persistent-hint
                          label="Certificate Type"></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense required v-model="editedItem.activity_id"
                          :items="activity_list" item-text="activity_title" item-value="activity_id" label="Activity Name" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions style="justify-content:  center;">
                  <!-- <v-spacer></v-spacer> -->
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch inset dense v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
        <template v-slot:item.template="{ item }"> <v-icon color="primary" style="cursor: pointer;" title="View Template Code" @click="viewTemplateCode(item)" > mdi-eye </v-icon> </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.isactive == true">
            <v-icon class="mr-2 pl-3 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 pl-3 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
            <v-avatar style="" size="25" class="edit-avatar ml-2">
              <v-icon class="v-icon-size mr-2 ml-2" @click="deleteItem(item)">delete</v-icon>
            </v-avatar>
            <!-- <v-switch v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggle(item)"></v-switch> -->
          </div>
        </template>
      </v-data-table>
<v-dialog v-model="templateCodeDialog" max-width="900px">
  <v-card>
    <v-card-title class="toolbar">
      <span>Certificate Template HTML Code</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="templateCodeDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <pre class="template-code">{{ selectedTemplateCode }}</pre>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn class="button" @click="templateCodeDialog = false">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from "xlsx";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      certificate_template_name: false,
    },
    snackbar_msg: "",
    templateCodeDialog: false,
selectedTemplateCode: "",
    participant_type_list: [],
    affiliation_type_list: [],
    activity_certificate_list: [],
    activity_list:[],
    academic_year_list: [],
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Certificate Template",
        align: "left",
        sortable: false,
        value: "certificate_template_name",
      },
      {
        text: "Template(HTMl Code)",
        align: "left",
        sortable: false,
        value: "template",
      },
      {
        text: "Participant Type",
        align: "left",
        sortable: false,
        value: "participant_type",
      },
      {
        text: "Affiliation Type",
        align: "left",
        sortable: false,
        value: "affiliaton_type",
      },
      {
        text: "Certificate Type",
        align: "left",
        sortable: false,
        value: "certificate_type",
      },
      {
        text: "Activity",
        align: "left",
        sortable: false,
        value: "activity_title",
      },

      {
        text: "Active",
        align: "center",
        sortable: true,
        value: "isactive",
      },
      {
        text: "Status",
        align: "center",
        sortable: true,
        value: "status",
      },
      { text: "Actions", value: "action", sortable: false, align: "center" },
    ],
    certificate_template_list: [],
    editedIndex: -1,
    addedItem: {
     certificate_template_name: "",
      participant_type_id: null,
      affiliaton_type_id: null,
      activity_certificate_id: null,
      academic_year_id: null,
      activity_id: null,
      template: ""
    },
    editedItem: {
      id: "",
      certificate_template_name: "",
      template: "",
      affiliaton_type_id:"",
      activity_certificate_id:"",
      affiliation_type:"",
      participant_name:"",
      activity_certificate_name:"",
      participant_type_id: "",
      activity_title:"",
      isactive: true,
    },
    defaultItem: {
      id: "",
      certificate_template_name: "",
      template: "",
      affiliaton_type_id:"",
      activity_certificate_id:"",
      affiliation_type:"",
      participant_name:"",
      activity_certificate_name:"",
      activity_title:"",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Certificate Template"
        : "Edit Certificate Template";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.feesComponent = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Activity/getCertificateTemplate")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            // this.activity_type_super_master_list =
            //   res.data.activity_type_super_master_list;
            this.certificate_template_list = res.data.certificate_template_list;
            this.participant_type_list = res.data.participant_type_list;
            this.affiliation_type_list = res.data.affiliation_type_list;
            this.activity_certificate_list = res.data.activity_certificate_list
            this.activity_list=res.data.activity_list
            this.academic_year_list = res.data.academic_year_list
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    viewTemplateCode(item) {
  this.selectedTemplateCode = item.template || "";
  this.templateCodeDialog = true;
},
    downloadFile() {
      this.loader = true;

      const excelData = this.certificate_template_list.map((item, index) => ({
        "S.No": index + 1,
        "Name": item.certificate_template_name,
        "Status": item.isactive ? "Active" : "Inactive"
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Certificate Template");
      XLSX.writeFile(workbook, "certificate_template.xlsx");

      this.loader = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.certificate_template_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this Certificate Template?")) {
        const data = {
          id: item.id
        };
        axios
          .post("/Activity/deleteCertificateTemplate", data)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Certificate Template Deleted Successfully...");
              this.onLoad();
            }
            else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
      this.close();
    },


    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Activity/editCertificateTemplate", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.certificate_template_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Certificate Template Updated successfully..."
                );
                this.onLoad();
              }
              else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Certificate Template already present!!!"); // show snackbar on error
                this.onLoad();
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.addedItem.certificate_template_name = "";
            });

          this.close();
        }
      } else {
        if (this.addedItem.certificate_template_name == "" || this.addedItem.certificate_template_name == null) {
          this.showSnackbar("#b71c1c", "Please enter Certificate Template...");
          return
        }
        axios
          .post("/Activity/saveCertificateTemplate", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.certificate_template_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Certificate Template added successfully..."
              );
              this.onLoad();
            }
            else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Certificate Template already present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem = {
              certificate_template_name: "",
              participant_type_id: null,
              affiliaton_type_id: null,
              activity_certificate_id: null,
              academic_year_id: null,
              activity_id: null,
              template: ""
            };
          });

        this.close();
      }
    },

    isValidated() {
      if (this.editedItem.certificate_template_name) {
        return true;
      } else {
        if (!this.editedItem.certificate_template_name) {
          this.showSnackbar("#b71c1c", "Please enter Certificate Template...");
          this.errorMsg.certificate_template_name = true;
        }

        return false;
      }
    },

        toggle(item) {
      const data = {
        id: item.id,
        isactive: item.isactive
      };
      axios
        .post("/Activity/toggleCertificateTemplate", data)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Certificate Template Updated Successfully...");
            this.onLoad();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      this.close();
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.active-switch-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.active-switch-container .v-switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.mytable ::v-deep tbody tr {
  min-height: 50px;
}

.mytable ::v-deep tbody td {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.template-code {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 65vh;
  overflow-y: auto;
  font-family: monospace;
  font-size: 13px;
  color: #212121;
}
</style>
